import React, { useEffect, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import './style.css'
import { db, collection, ref, onSnapshot, uploadBytes, storage } from '../../config/firebase';
import { BestPdf } from "./BestPdf";


const ref2 = React.createRef();
function TestPdf() {
  const uid = JSON.parse(localStorage.getItem("Student"));
  const [data, setData] = useState([]);
  useEffect(() => {
    const q = collection(db, "Students");
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const newData = [];
      snapshot.forEach((doc) => {
        if (uid?.uid == doc.id)
          newData.push(doc.data());
      });
      setData(newData);
    });
  }, []);

  console.log('ss',data[0])

  const downloadPDF = () => {
    const input = ref2.current;

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4', true);
      const pdfwidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfwidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfwidth - imgWidth * ratio) / 2;
      const imgY = 30;
      pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      pdf.save('std.pdf');

      const blob = pdf.output("blob");
      const storageRef = ref(storage, `pdfs/${uid.uid}`);

      uploadBytes(storageRef, blob).then((snapshot) => {
        console.log('Uploaded a blob or file!');
      });
    })
  }

  return (
    <div className="bg-white">
      {/* <div className="flex justify-center">
        <Button
          style={{ backgroundColor: "#0B5F68" }}
          className="flex justify-center "
          onClick={downloadPDF}
        >
          Please Download Id Card
        </Button>
      </div> */}
<BestPdf></BestPdf>

      {/* ID Card Container */}
      {/* <div className="flex bg-white justify-center flex-col items-center p-3 sm:p-5 md:p-10 lg:p-16"
        ref={ref2}>
        <div className="bg-white w-full">
          <div className="bg-white w-full sm:w-11/12 md:w-4/5 lg:w-3/4 xl:w-2/3 border-2 border-teal-600 rounded-lg" style={{ width: "100%", minHeight: "15rem" }}>
          
            <h3 className="text-white text-lg md:text-xl font-bold bg-teal-600 p-2 text-center">
              ID Card
            </h3>

          
            <div className="flex flex-col md:flex-row items-center space-y-2 md:space-x-5 p-5">
       
              <div className="text-black flex flex-col w-full md:w-2/3">
                <div className="text-left mb-3">
                  <h1 className="text-sm md:text-base">
                    <span className="text-teal-600">Roll No:</span>{" "}
                    <span className="font-bold">{data[0]?.rollNumber}</span>
                  </h1>
                  <h1 className="text-sm md:text-base mt-1">
                    <span className="text-teal-600">Name:</span>{" "}
                    <span className="font-bold">{data[0]?.name}</span>
                  </h1>
                  <h1 className="text-sm md:text-base mt-1">
                    <span className="text-teal-600">Father Name:</span>{" "}
                    <span className="font-bold">{data[0]?.fname}</span>
                  </h1>
                  <h1 className="text-sm md:text-base mt-1">
                    <span className="text-teal-600">City:</span>{" "}
                    <span className="font-bold">{data[0]?.city}</span>
                  </h1>
                </div>
              </div>

              <div className="h-24 w-48 sm:h-32 sm:w-48 md:h-24 md:w-48 lg:h-32 lg:w-48 xl:h-32 xl:w-48 border-2 border-teal-600 rounded-lg overflow-hidden">
                <img
                  src={props.pic}
                  className="w-full h-full"
                  alt="Student Photo"
                />
              </div>
            </div>
          </div>
        </div>



 
        <div className="bg-white mt-3 sm:mt-5 md:mt-8">
          <span className="text-left text-black">
            <h1 style={{ color: "#0B5F68" }} className="text-center font-bold text-sm md:text-2xl">Payment Method</h1>
            <h2 className="italic text-xs sm:text-sm md:text-xl mb-2">Online Via Easy Paisa:</h2>
            <h3 className="text-justify indent-0 md:indent-8 text-xs sm:text-sm md:text-base">
              Go to any Mobile Communication shop & ask him to transfer fees i.e. Rs. <b className="font-bold">2000</b> (3 months’ fees) to this number <span className="font-bold">03434192648</span> via Easy Paisa, or if you have an account on Easy Paisa, you can transfer via it as well. Once the payment is done, please submit the screenshot above. For Further queries contact the Official number <span className="font-bold">03434192648</span>
            </h3>
          </span>
        </div>

        <div className="bg-white mt-3 sm:mt-5 md:mt-8 urdu">
          <span className="text-left text-black">
            <h1 style={{ color: "#0B5F68" }} className="text-center font-bold text-sm md:text-2xl">ادائیگی کا طریقہ</h1>
            <h2 className="italic text-xs sm:text-sm md:text-xl text-end mb-2">آن لائن بذریعہ ایزی پیسہ</h2>
            <h3 className="text-end indent-0 md:indent-8 text-xs sm:text-sm md:text-base">
              کسی بھی موبائل کمیونیکیشن شاپ پر جائیں اور اس سے فیس ٹرانسفر کرنے کے لیے کہیں یعنی 2000 روپے (3 ماہ کی فیس) ​​اس نمبر 0343-4192648 پر ایزی پیسہ کے ذریعے، یا اگر آپ کا ایزی پیسہ پر اکاؤنٹ ہے، تو آپ اس کے ذریعے بھی ٹرانسفر کر سکتے ہیں۔ ادائیگی ختم ہونے کے بعد، براہ کرم اوپر اسکرین شاٹ جمع کرائیں۔ مزید سوالات کے لیے آفیشل نمبر 0343-4192648 پر رابطہ کریں۔
            </h3>
          </span>
        </div>
      </div>
  {*/} 
    </div>
  );
}

export default TestPdf;